const { default: axios } = require("axios");

const FormAjax = function () {

    const formCart = function (e) {

        //const values = form.serialize();
        const form = $(this);
        var values = new FormData(this);
        const button = form.find('button');

        button.attr('disabled', 'disabled');
        button.find('p').text('ADICIONANDO...');

        Swal.fire({
            title: '',
            allowOutsideClick: false,
            showCancelButton: false,
            showCloseButton: false,
            background: 'transparent',
            didOpen: () => {
                Swal.showLoading()
            }
        });

        axios.post(form.attr('action'), values)
            .then(function (response) {
                const data = response.data;
                let result = data.result;

                const productActived = $('.wrap-options-color').find('.act-bt-color.buy-choose-option.el-class-toggle.actived');

                // SEND GTM EVENT
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        currency: "BRL",
                        value: productActived.length <=0 ? $("#form-data-price").val() : productActived.attr('data-price'),
                        items: [{
                            item_id: productActived.length <=0 ? $("#form-data-sku").val() : productActived.attr('data-sku'),
                            item_name: productActived.length <=0 ? $("#form-data-title").val() : productActived.attr('data-title'),
                            item_brand: "Boske",
                            item_category: "Pet",
                            price: productActived.length <=0 ? $("#form-data-price").val() : productActived.attr('data-price'),
                            quantity: 1
                        }]
                    }
                });

                if ($('.action-add-component.actived').length > 0) {
                    /* if ($('.action-add-component.actived').data('id_product') != undefined) {
                        const componentData = $('.action-add-component.actived').data();
                        delete componentData['next'];

                        console.log('tem componente', componentData);

                        axios.post(form.attr('action'), componentData)
                            .then(function (response) {

                                const componentActived = $('#list-add-item').find('.action-add-component.actived');

                                // SEND GTM EVENT
                                dataLayer.push({
                                    event: "add_to_cart",
                                    ecommerce: {
                                        currency: "BRL",
                                        value: componentActived.attr('data-price'),
                                        items: [{
                                            item_id: componentActived.attr('data-sku'),
                                            item_name: componentActived.attr('data-title'),
                                            item_brand: "Boske",
                                            item_category: "Pet",
                                            price: componentActived.attr('data-price'),
                                            quantity: 1
                                        }]
                                    }
                                });

                            }).catch(error => {

                            });
                    } */
                   $('.action-add-component.actived').each(function () {
                        const _el = $(this);
                        if (_el.data('id_product') !== undefined) {
                            console.log(_el.data('id_product'));
                            let componentData = _el.data();
                            delete componentData.next;
                            axios.post(form.attr('action'), componentData)
                            .then(function(res){

                                // SEND GTM EVENT
                                dataLayer.push({
                                    event: "add_to_cart",
                                    ecommerce: {
                                        currency: "BRL",
                                        value: _el.attr('data-price'),
                                        items: [{
                                            item_id: _el.attr('data-sku'),
                                            item_name: _el.attr('data-title'),
                                            item_brand: "Boske",
                                            item_category: "Pet",
                                            price: _el.attr('data-price'),
                                            quantity: 1
                                        }]
                                    }
                                });
                                
                            });
                        }

                    });
                }

                Swal.close();

                // Swal.fire({
                //     // icon: data.error == false ? 'success' : 'error',
                //     title: data.message,
                //     showConfirmButton: false,
                //     timer: 3000
                // })

                

                setTimeout(() => {

                    let countCar = parseInt($('.cart-count').text());
                    countCar = countCar + 1;
                    $('.cart-count').find('p').text(countCar);

                    button.removeAttr('disabled');
                    button.find('p').text('ADICIONAR');

                    form.trigger("reset");

                    window.location.href = CHECKOUT_URL + 'resolve-checkout/?list_hash=' + data.result.list_hash;

                }, 2000);

            }).catch(error => {
                Swal.fire({
                    // icon: 'error',
                    title: error,
                    showConfirmButton: true,
                    timer: 3000
                })
                console.log(error);
                button.removeAttr('disabled');
                button.find('p').text('ADICIONAR');
            });

        e.preventDefault();
    }

    const formAjax = function (e) {

        //const values = form.serialize();
        const form          = $(this);
        var values          = new FormData(this);
        const button        = form.find('button');
        const loaderStatus  = form.find('.loader-forms');

        //Recaptcha Google V2 box
        var reCaptchaValided = true;
        var hasRecaptcha = false;

        form.find('.custom-captcha-error').hide();
        if (form.find("[name=g-recaptcha-response]").length > 0) {
            hasRecaptcha = true;
            if (form.find("[name=g-recaptcha-response]").val() === '') {
                e.preventDefault();
                form.find('.custom-captcha-error').show();
                reCaptchaValided = false;
            }
        }

        if (!reCaptchaValided) {
            return false;
        }

        button.attr('disabled', 'disabled');
        // button.find('p').text('ENVIANDO...');

        loaderStatus.find('.status-send').text(loaderStatus.find('.status-send').attr('data-text'));
        loaderStatus.addClass('active').fadeIn();
        loaderStatus.find('svg').fadeIn();
        console.log(loaderStatus.attr('data-text'));

        // Swal.fire({
        //     title: '',
        //     allowOutsideClick: false,
        //     showCancelButton: false,
        //     showCloseButton: false,
        //     background: 'transparent',
        //     didOpen: () => {
        //         Swal.showLoading()
        //     }
        // });

        axios.post(form.attr('action'), values)
            .then(function (response) {
                const data = response.data;

                Swal.close();

                // Swal.fire({
                //     icon: data.error == false ? 'success' : 'error',
                //     title: data.message,
                //     showConfirmButton: false,
                //     timer: 3000
                // })

                loaderStatus.find('.status-send').text(data.error == false ? "Enviado com sucesso!" : "Ops, ocorreu um erro...");
                loaderStatus.find('svg').fadeOut();
                setTimeout(() => {
                    loaderStatus.removeClass('active');
                    loaderStatus.find('.status-send').text('');
                }, 5000);

                if (hasRecaptcha) {
                    var c = $('.g-recaptcha').length;
                    for (var i = 0; i < c; i++)
                        grecaptcha.reset(i);
                }

                button.removeAttr('disabled');
                // button.find('p').text('INSCREVA-SE');

                form.trigger("reset");

            }).catch(error => {
                loaderStatus.find('.status-send').text("Ops, ocorreu um erro...");
                console.log(error);
                button.removeAttr('disabled');
                setTimeout(() => {
                    loaderStatus.removeClass('active');
                }, 5000);
                // button.find('p').text('INSCREVA-SE');
            });

        e.preventDefault();
    }

    const CaptchaCallback = function () {
        $('.g-recaptcha').each(function (index, el) {
            grecaptcha.render(el, {
                'sitekey': $(el).attr('data-sitekey')
                , 'theme': $(el).attr('data-theme')
                , 'size': $(el).attr('data-size')
                , 'tabindex': $(el).attr('data-tabindex')
                , 'callback': $(el).attr('data-callback')
                , 'expired-callback': $(el).attr('data-expired-callback')
                , 'error-callback': $(el).attr('data-error-callback')
            });

        });
    };

    const formShipping = function (e) {
        e.preventDefault();

        const form = $(this);
        const button = form.find('button');
        
        button.prop('disabled', true);
        button.find('p').text('');

        // loading
        const idLoading = '#loader-frete';
        $(idLoading).fadeIn(100);

        let zipcode = $(this).find('#cep').val();
        let uri = $(this).attr('action');

        let data = {
            'zipcode': zipcode
        };

        if ($('.action-add-component.actived').length > 0) {
            if ($('.action-add-component.actived').data('id_product') != undefined) {
                let component_id = $('.action-add-component.actived').data('id_product');

                data['component_id'] = component_id;
            }
        }

        axios.post(uri, data).then(function (response) {
            const data = response.data;
            let result = data.result;

            console.log(result);
            
            $('.response-calculate-shipping').addClass('active');
            $('.response-calculate-shipping').html(result.html);
            $(idLoading).fadeOut(200);

            button.prop('disabled', false);
            button.find('p').text(button.data('text'));
        });

    }

    return {
        init: function () {
            $(document).on('submit', '.form-ajax-cart', formCart);
            $(document).on('submit', '.form-ajax', formAjax);
            $(document).on('submit', '.form-shipping', formShipping);
            // CaptchaCallback();

            //evento GTM click to cart
            /* document.querySelector(".act-bt-buy").addEventListener("click", function() {
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                    currency: "BRL",
                    value: 99.90,
                    items: [{
                        item_id: "SKU_123",
                        item_name: "Nome do Produto",
                        item_brand: "Marca",
                        item_category: "Categoria",
                        price: 99.90,
                        quantity: 1
                    }]
                    }
                });
            });  */

        }
    }
}();

module.exports = FormAjax;
